<div class="position-fixed p-3" style="z-index: 9999;">
  @for (toast of toastService.toasts; track toast) {
    <ngb-toast
      [class]="toast.classname"
      [autohide]="true"
      [delay]="toast.delay || 200000"
      (hidden)="toastService.remove(toast)"
    >
      <div class="d-flex justify-content-between">
        <div class="font-18">{{toast.text}}</div>
        <div class="ms-2">
          <button type="button" aria-label="Close" class="btn-close"
            (click)="toastService.remove(toast)"></button>
        </div>
      </div>
    </ngb-toast>
  }
</div>
